import { render, staticRenderFns } from "./RetencionListado.vue?vue&type=template&id=5ea4d2ac&scoped=true"
import script from "./RetencionListado.vue?vue&type=script&lang=js"
export * from "./RetencionListado.vue?vue&type=script&lang=js"
import style1 from "./RetencionListado.vue?vue&type=style&index=1&id=5ea4d2ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ea4d2ac",
  null
  
)

export default component.exports